import { Line } from 'react-native-svg';
import { tokens } from '../../theme/tokens';
import type { KnowledgeGraphNodeStatus } from '../../types/learningAnalysis';

type KnowledgeGraphEdgeProps = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  active?: boolean;
  sourceStatus?: KnowledgeGraphNodeStatus;
  targetStatus?: KnowledgeGraphNodeStatus;
};

const getEdgeColor = (
  sourceStatus?: KnowledgeGraphNodeStatus,
  targetStatus?: KnowledgeGraphNodeStatus
) => {
  if (sourceStatus === 'weak' || targetStatus === 'weak') {
    return tokens.colors.danger;
  }
  if (sourceStatus === 'review' || targetStatus === 'review') {
    return tokens.colors.warning;
  }
  return tokens.colors.success;
};

export function KnowledgeGraphEdge({
  x1,
  y1,
  x2,
  y2,
  active = false,
  sourceStatus,
  targetStatus,
}: KnowledgeGraphEdgeProps) {
  const stroke = getEdgeColor(sourceStatus, targetStatus);

  return (
    <>
      <Line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={tokens.colors.border}
        strokeLinecap="round"
        strokeWidth={active ? 8 : 6}
      />
      <Line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={stroke}
        strokeLinecap="round"
        strokeOpacity={active ? 0.64 : 0.28}
        strokeWidth={active ? 3 : 2}
      />
    </>
  );
}
